import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import useComponent from './useComponent';
import Desktop from './desktop';
import Mobile from './mobile';

const AttributeBottomSheet = ({
  value = [],
  productOptions = [],
  onApply,
  onAttributeCreated,
  disabled = false,
  buttonText = 'Thêm thuộc tính',
}) => {
  var isMobile = useIsMobile(992);
  
  const viewModel = useComponent({ value, productOptions, onApply, onAttributeCreated });

  return isMobile
    ? <Mobile viewModel={viewModel} disabled={disabled} buttonText={buttonText} />
    : <Desktop viewModel={viewModel} disabled={disabled} buttonText={buttonText} />;
};

export default AttributeBottomSheet;
